import React, { useEffect, useState } from 'react';
import './styles';
import { useDispatch, useSelector } from 'react-redux';
import UIIcon from '../UIIcon';
import { CloseIcon } from '../../../assets/icons';
import UILabeledInput from '../UILabeledInput';
import { useHistory } from 'react-router-dom';
import { updatePage, updateSearch, updateSearchField } from '../../../redux/store/filters/actions';
import { getIsUserAdminSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { getReduxFiltersSelector } from '../../PL/PLTable/selectors';
import { getScreenTypeSelector } from '../../../redux/selectors/ControlSelectors';

export const UI_SEARCH_BAR_TYPES = {
	service: 'service',
	listing: 'listing',
	serviceRequest: 'serviceRequest',
	user: 'user',
	option: 'option',
	region: 'region',
	inviteCode: 'inviteCode',
	zipCode: 'zipCode'
};

export default function UISearchBar({ type, onSearchUpdated, placeholder, searchBarWidth, className, style }: UISearchBarProps) {
	const screenType = useSelector(getScreenTypeSelector);
	const filters = useSelector(getReduxFiltersSelector);
	const isUserAdmin = useSelector(getIsUserAdminSelector);

	const history = useHistory();
	const dispatch = useDispatch();

	const matchingPath = history.location.pathname;

	const [value, setValue] = useState(filters[matchingPath]?.search);

	const getOptionsFromType = (type) => {
		if (type === UI_SEARCH_BAR_TYPES.user) {
			return [
				{
					value: 'name',
					label: 'Name'
				}
			];
		} else if (type === UI_SEARCH_BAR_TYPES.inviteCode) {
			return [
				{
					value: 'inviteCode',
					label: 'inviteCode'
				}
			];
		} else if (type === UI_SEARCH_BAR_TYPES.zipCode) {
			return [
				{
					value: 'zipCode',
					label: 'zipCode'
				}
			];
		} else if (type === UI_SEARCH_BAR_TYPES.service) {
			if (isUserAdmin) {
				return [
					{
						value: 'address',
						label: 'Address'
					},
					{
						value: 'externalAgentEmail',
						label: 'Coldwell Email'
					}
				];
			}
			return [
				{
					value: 'address',
					label: 'Address'
				}
			];
		} else if (type === UI_SEARCH_BAR_TYPES.listing) {
			return [
				{
					value: 'address',
					label: 'Address'
				}
			];
		}
		return [
			{
				value: 'name',
				label: 'Name'
			}
		];
	};

	const options = getOptionsFromType(type);

	useEffect(() => {
		dispatch(updateSearchField({ route: matchingPath, value: options[0].value }));
	}, []);

	const onChange = (value) => {
		setValue(value);
		updateValue(value);
	};

	const updateValue = (value) => {
		dispatch(updateSearch({ route: matchingPath, value: value }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		if (onSearchUpdated) {
			onSearchUpdated();
		}
	};

	const iconStyle = { width: 16, height: 16, margin: '0 8px' };

	let showDropdown = options.length > 1 && screenType !== 'mobile';

	return (
		<div className={`plSearchBar ${className}`} style={showDropdown ? { ...style, maxWidth: 512 } : style}>
			<div className='plSearchBar__inputContainer'>
				<div className='plSearchBar__inputContainer--wrap'>
					<UILabeledInput
						value={value}
						placeholder={placeholder}
						onChangeValue={onChange}
						style={{ width: searchBarWidth }}
						className='plSearchBar__inputContainer--wrap-input'
						iconStyle={{ ...iconStyle, cursor: 'pointer', width: searchBarWidth }}
					/>
				</div>
				{value && (
					<UIIcon
						className='plSearchBar__inputContainer--wrap-button'
						onClick={() => onChange('')}
						style={{ ...iconStyle, cursor: 'pointer', width: searchBarWidth }}
						iconSrc={CloseIcon.white}
						alt={'close'}
					/>
				)}
			</div>
		</div>
	);
}
